<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="290"
    style="overflow:hidden;"
  >
    <v-card
      style="overflow:hidden;padding: 0 10px;"
    >
      <v-card-title class="text-h5">
        A�adir asistentes
      </v-card-title>
      <div v-if="editedItem">
        <v-row>
          <v-col
            cols="12"
            sm="12"
            style="padding: 15px 15px 0 15px;"
          >
            <table width="100%">
              <tr>
                <td>
                  <v-btn
                    block
                    @click="handleChangeAdults(-1)"
                  >
                    - 1
                  </v-btn>
                </td>
                <td
                  style="padding: 5px;width:140px;"
                >
                  <custom-text-field-number
                    v-model="editedItem.adults"
                    label="Adultos"
                    dense
                  />
                </td>
                <td>
                  <v-btn
                    block
                    @click="handleChangeAdults(+1)"
                  >
                    + 1
                  </v-btn>
                </td>
              </tr>
            </table>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            style="padding: 0 15px 15px 15px;"
          >
            <table width="100%">
              <tr>
                <td>
                  <v-btn
                    block
                    @click="handleChangeChildren(-1)"
                  >
                    - 1
                  </v-btn>
                </td>
                <td
                  style="padding: 5px;width:140px;"
                >
                  <custom-text-field-number
                    v-model="editedItem.children"
                    label="Ni�os"
                    dense
                  />
                </td>
                <td>
                  <v-btn
                    block
                    @click="handleChangeChildren(+1)"
                  >
                    + 1
                  </v-btn>
                </td>
              </tr>
            </table>
          </v-col>
        </v-row>
      </div>
      <v-card-actions style="padding: 0 0 10px 0;">
        <v-spacer />
        <v-btn
          @click="onClose(false)"
        >
          cancelar
        </v-btn>
        <v-btn
          color="black"
          dark
          @click="handleSave"
        >
          guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import api from '@/services/api'
import utils from '@/services/utils'
import CustomTextFieldNumber from '@/components/CustomTextFieldNumber'
export default {
  components: {
    CustomTextFieldNumber,
  },
  props: {
    selectedPlanID: {
      type: String,
      required: true,
    },
    selectedEvent: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    dialog: false,
    editedItem: null,
  }),
  computed: {
    contentTypeID () {
      return this.$route.params.id
    },
    userID () {
      return utils.getUser()
    },
  },
  watch: {
    selectedEvent () {
      this.handlePrepareData()
    },
  },
  mounted () {
      this.handlePrepareData()
  },
  methods: {
    handlePrepareData () {
      if (!this.selectedEvent) {
        this.editedItem = null
        this.dialog = false
        return
      }
      this.editedItem = JSON.parse(JSON.stringify(this.selectedEvent))
      this.dialog = true
    },
    handleSave () {
      api.updateItem ('dviewcontent', `v1/private/activity-barcelo-01/events/${this.contentTypeID}/${this.selectedPlanID}/`, this.editedItem.id.concat('/pax-count'), this.editedItem)
        .then(() => {
          this.onClose(true)
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleChangeAdults (v) {
      if (v < 0 && this.editedItem.adults === 0) return
      this.editedItem.adults += v
    },
    handleChangeChildren (v) {
      if (v < 0 && this.editedItem.children === 0) return
      this.editedItem.children += v
    },
  },
}
</script>


